var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 388.309 388.309",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M201.173 307.042a49.114 49.114 0 0 1-30.825-11.494l-56.947-50.155c-8.961-8.373-22.664-9.036-32.392-1.567L.03 303.384v38.661c-.582 10.371 7.355 19.25 17.726 19.832.534.03 1.07.037 1.605.021h286.824c11.494 0 22.988-8.359 22.988-19.853V240.691L226.25 300.25a47.545 47.545 0 0 1-25.077 6.792z",
    fill: "#936edd",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.993,
    cy: 182.699,
    r: 22.988,
    fill: "#936edd",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.508 67.238a19.332 19.332 0 0 0-14.106-7.837L84.667 26.487a24.03 24.03 0 0 0-15.673 4.18 24.03 24.03 0 0 0-7.837 13.584l-4.702 40.751h249.731c23.809.54 43.061 19.562 43.886 43.363v184.424c0-1.045 4.702-2.09 6.792-4.18a17.762 17.762 0 0 0 6.792-14.106L388.21 82.389a20.38 20.38 0 0 0-4.702-15.151z",
    fill: "#936edd",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.185 105.899H19.361C7.867 105.899.03 116.87.03 128.364v148.898l68.963-50.155c17.506-12.986 41.724-11.895 57.992 2.612l57.469 50.155a26.643 26.643 0 0 0 30.824 2.612l113.894-66.351v-87.771c-.79-12.265-10.707-21.956-22.987-22.465zM196.993 226.584c-24.237 0-43.886-19.648-43.886-43.886 0-24.237 19.648-43.886 43.886-43.886 24.237 0 43.886 19.648 43.886 43.886 0 24.238-19.648 43.886-43.886 43.886z",
    fill: "#936edd",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.0184923e8551a709c7bcb55916c642c3.svg";
export { ForwardRef as ReactComponent };